import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiError } from "@/lib/api";
import { identify, trackCompleteRegistration } from "@/lib/pixel";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, obj=user

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      identify({ email: data.email, id: data.id });
    } catch {
      setUser(false); // 401 = guest; not an error worth logging
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from Google OAuth callback, skip /me — AuthCallback handles it first.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const loginWithGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    identify({ email: data.email, id: data.id });
    return data;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data);
    identify({ email: data.email, id: data.id });
    trackCompleteRegistration({ method: "email" });
    return data;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (err) { console.warn("Logout request failed; clearing local session anyway", err); }
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refresh, loginWithGoogle, formatApiError }}>
      {children}
    </AuthContext.Provider>
  );
}
